// TODO: Update to use Orbit's components instead
// eslint-disable-next-line no-restricted-imports
import {
  Slider,
  SliderFilledTrack,
  SliderMark,
  SliderThumb,
  SliderTrack,
} from '@chakra-ui/react';
import React from 'react';

import Config from 'src/lib/config';
import { UserPermission } from 'src/lib/graphqlTypes/types';

export const UserRolesSlider = ({
  minEditRole,
  setMinEditRole,
  excludedRoles,
  className,
  label,
}: {
  minEditRole: UserPermission | null;
  setMinEditRole: (minEditRole: UserPermission | null) => void;
  excludedRoles?: UserPermission[];
  className?: string;
  label?: string;
}) => {
  const rolesRanked = Config.orderedGraphRoles
    .slice()
    .filter((role) => !excludedRoles?.includes(role))
    .reverse() as UserPermission[];

  const roleRank = minEditRole ? rolesRanked.indexOf(minEditRole) : 0;
  const roleDisplayNames = [
    'Admins',
    ...rolesRanked.slice(1).map((val) => `${Config.roleNameByRoleEnum[val]}s`),
  ];

  return (
    <Slider
      defaultValue={roleRank}
      min={0}
      max={rolesRanked.length - 1}
      step={1}
      onChange={(val) => {
        const newEditRole = rolesRanked[val];
        if (newEditRole && newEditRole !== UserPermission.GRAPH_ADMIN) {
          setMinEditRole(newEditRole);
        } else {
          setMinEditRole(null);
        }
      }}
      className={className}
      aria-label={label}
    >
      {roleDisplayNames.map((role, index) => (
        <SliderMark key={role} value={index} mt="1.5" fontSize="sm">
          <div className="relative -left-1/2 text-secondary">{role}</div>
        </SliderMark>
      ))}
      <SliderTrack>
        <SliderFilledTrack />
      </SliderTrack>
      <SliderThumb />
    </Slider>
  );
};
